import React, { useEffect, useState, useContext } from 'react'
import { usePosition } from '../../hooks/CompanyConfiguration/usePosition'
import { ConfigurationContext } from '../../context api/Configuration/ConfigurationContext'
import Modal from '@material-ui/core/Modal'
import styles from './FilterArray.module.css'
import Button from '@material-ui/core/Button'
import { CircularProgress, TextField } from '@material-ui/core'

const ShowPositionFilter = ({ open, setOpen, filterParams, setFilterParams }) => {
  const [popperFilterPara, setPopperFilterPara] = useState([])
  const { positions } = useContext(ConfigurationContext)

  const { getAllPosition, loading } = usePosition()

  useEffect(() => {
    getAllPosition()
  }, [])

  useEffect(() => {
    if (positions) {
      let temp = []
      positions.forEach((item) => {
        temp.push({
          name: item.positionName,
          id: item._id,
          active: false,
        })
      })
      setPopperFilterPara(temp)
    }
  }, [positions])

  const handleChange = (event, index) => {
    let tempPara = [...popperFilterPara]
    tempPara[index].active = event.target.checked
    setPopperFilterPara(tempPara)
  }

  const handleFilter = () => {
    setOpen(false)
    let tempPositionId = []
    popperFilterPara.forEach((para) => {
      if (para.active) tempPositionId.push(para.id)
    })
    setFilterParams({
      ...filterParams,
      page: 1,
      positionId: tempPositionId,
    })
  }

  const handleCancel = () => {
    setOpen(false)
    let tempPositionPara = [...popperFilterPara]
    popperFilterPara.forEach((para, index) => {
      if (filterParams.positionId) {
        tempPositionPara[index].active = filterParams.positionId.includes(para.id)
      } else tempPositionPara[index].active = false
    })
    setPopperFilterPara(tempPositionPara)
  }

  return (
    <Modal open={open} onClose={handleCancel} className={styles.modal}>
      <div className={styles.container}>
        {!loading ? (
          popperFilterPara.length ? (
            <React.Fragment>
              {popperFilterPara.map((param, index) => {
                return (
                  <React.Fragment>
                    <div>
                      <input type="checkbox" checked={param.active} name={param.name} id={param.id} onChange={(event) => handleChange(event, index)} />
                      <label htmlFor={param.id}>{param.name}</label>
                    </div>
                  </React.Fragment>
                )
              })}
              <div>
                <Button onClick={handleCancel} variant="contained" color="primary">
                  Cancel
                </Button>
                <Button onClick={handleFilter} variant="contained" color="primary">
                  Filter
                </Button>
              </div>
            </React.Fragment>
          ) : (
            <div>No Positions to Filter</div>
          )
        ) : (
          <div>
            <CircularProgress />
          </div>
        )}
      </div>
    </Modal>
  )
}

const ShowStatusFilter = ({ open, setOpen, filterParams, setFilterParams }) => {
  const [popperFilterPara, setPopperFilterPara] = useState([
    {
      name: 'present',
      active: false,
    },
    {
      name: 'absent',
      active: false,
    },
    {
      name: 'leave',
      active: false,
    },
  ])

  const handleChange = (event, index) => {
    let tempPara = [...popperFilterPara]
    tempPara[index].active = event.target.checked
    setPopperFilterPara(tempPara)
  }

  const handleFilter = () => {
    setOpen(false)
    let tempStatus = []
    popperFilterPara.forEach((para) => {
      if (para.active) tempStatus.push(para.name)
    })
    setFilterParams({
      ...filterParams,
      page: 1,
      status: tempStatus,
    })
  }

  const handleCancel = () => {
    setOpen(false)
    let tempPara = [...popperFilterPara]
    popperFilterPara.forEach((para, index) => {
      if (filterParams.status) {
        tempPara[index].active = filterParams.status.includes(para.name)
      } else tempPara[index].active = false
    })
    setPopperFilterPara(tempPara)
  }

  return (
    <Modal open={open} onClose={handleCancel} className={styles.modal}>
      <div className={styles.container}>
        {popperFilterPara ? (
          popperFilterPara.length ? (
            <React.Fragment>
              {popperFilterPara.map((param, index) => {
                return (
                  <React.Fragment>
                    <div>
                      <input type="checkbox" checked={param.active} name={param.name} id={param.name} onChange={(event) => handleChange(event, index)} />
                      <label htmlFor={param.name}>{param.name}</label>
                    </div>
                  </React.Fragment>
                )
              })}
              <div>
                <Button onClick={handleCancel} variant="contained" color="primary">
                  Cancel
                </Button>
                <Button onClick={handleFilter} variant="contained" color="primary">
                  Filter
                </Button>
              </div>
            </React.Fragment>
          ) : (
            <div>No Status to Filter</div>
          )
        ) : (
          <div>
            <CircularProgress />
          </div>
        )}
      </div>
    </Modal>
  )
}

function CustomFilterModal({ open, setOpen, data, fieldValue, fieldName, handleFilter, filterParams = [] }) {
  // data will be array of objects
  const [popperFilterPara, setPopperFilterPara] = useState(false) // data after search query
  const [initialFilter, setInititalFilter] = useState(false)
  const [filterData, setFilterData] = useState(false)

  console.log({ data })

  useEffect(() => {
    if (data) {
      let temp = data.map((item, index) => {
        let active = filterParams.indexOf(item[fieldValue])
        // actual index will be of filter data
        // so we can change active in filterdata too
        return {
          value: item[fieldValue],
          name: item[fieldName],
          active: active !== -1 ? true : false,
          actualIndex: index,
        }
      })
      setFilterData(temp)
      setPopperFilterPara(temp)
    }
  }, [open, data])

  const handleChange = (event, index, actualIndex) => {
    let tempPara = [...popperFilterPara]
    tempPara[index].active = event.target.checked

    let tempFilterData = [...filterData]
    tempFilterData[actualIndex].active = event.target.checked

    setFilterData(tempFilterData)
    setPopperFilterPara(tempPara)
  }

  const handleFilterButton = () => {
    setOpen(false)
    let tempFilter = []
    popperFilterPara.forEach((para) => {
      if (para.active) tempFilter.push(para.value)
    })
    handleFilter(tempFilter)
    setInititalFilter(filterData)
  }

  const handleReset = () => {
    let tempPara = popperFilterPara.map((val) => ({ ...val, active: false }))

    let tempFilterData = filterData.map((val) => ({ ...val, active: false }))

    setFilterData(tempFilterData)
    setPopperFilterPara(tempPara)
  }

  const handleCancel = () => {
    setOpen(false)
    setPopperFilterPara(initialFilter)
    setFilterData(initialFilter)
  }

  const handleSearchField = (event) => {
    let tempSearchData = filterData.filter((item) => item.name && item.name.toLowerCase().includes(event.target.value.toLowerCase()))
    setPopperFilterPara(tempSearchData)
  }

  return (
    <Modal open={open} onClose={handleCancel} className={styles.modal}>
      <div className={styles.container}>
        {filterData ? (
          filterData.length ? (
            <React.Fragment>
              <TextField className={styles.searchField} label="Search" onChange={handleSearchField} />
              <br />
              <div className={styles.filterParaDiv}>
                {popperFilterPara.map((param, index) => {
                  return (
                    <React.Fragment>
                      <div>
                        <input type="checkbox" checked={param.active} name={param.name} id={param.name} onChange={(event) => handleChange(event, index, param.actualIndex)} />
                        <label htmlFor={param.name}>{param.name}</label>
                      </div>
                    </React.Fragment>
                  )
                })}
              </div>
              <div>
                <Button onClick={handleReset} variant="contained" color="primary">
                  Reset
                </Button>
                <Button onClick={handleCancel} variant="contained" color="primary">
                  Cancel
                </Button>
                <Button onClick={handleFilterButton} variant="contained" color="primary">
                  Filter
                </Button>
              </div>
            </React.Fragment>
          ) : (
            <div>No Data to Filter</div>
          )
        ) : (
          <div>
            <CircularProgress />
          </div>
        )}
      </div>
    </Modal>
  )
}

export default CustomFilterModal
export { ShowPositionFilter, ShowStatusFilter }
